"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../data/constants");
var constantsClasses_1 = require("../../data/constantsClasses");
var NavigationElement_1 = __importDefault(require("./NavigationElement"));
var Navigation = /** @class */ (function () {
    function Navigation() {
        var _this = this;
        this.navigationElements = [];
        document.querySelectorAll("[".concat(constants_1.DATA_NAVIGATION_MENU, "]")).forEach(function (element) {
            _this.navigationElements.push(new NavigationElement_1.default(element));
        });
        if (this.navigationElements.length < 1)
            return;
        this.menuOpenBtn = document.querySelector("[".concat(constants_1.DATA_HEADER_MENU_BTN, "]"));
        this.windowWith = window.innerWidth;
        this.initEventListeners();
    }
    /**
     * Init menu components
     * @private
     */
    Navigation.prototype.initEventListeners = function () {
        var _this = this;
        // Close menus on resize
        window.addEventListener('resize', function () {
            // workaround for iOS
            if (window.innerWidth != _this.windowWith) {
                _this.windowWith = window.innerWidth;
                _this.closeAll();
            }
        });
        // Close dropdowns on outside click
        document.addEventListener('click', function (event) {
            _this.checkForOutsideClick(event);
        });
        // Open menu button (mobile)
        this.menuOpenBtn.addEventListener('click', function () {
            _this.menuOpenBtn.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
            document.body.classList.toggle(constantsClasses_1.NAV_OPEN);
            _this.navigationElements.forEach(function (nav) {
                nav.getElement().classList.toggle(constantsClasses_1.CLASS_ACTIVE);
            });
        });
        // Open/Close sub menus
        this.navigationElements.forEach(function (nav) {
            nav.NavigationItems.forEach(function (element) {
                var subOpen = element.querySelector("[".concat(constants_1.DATA_NAVIGATION_SUB_OPEN, "]"));
                var subClose = element.querySelector("[".concat(constants_1.DATA_NAVIGATION_SUB_BACK, "]"));
                subOpen.addEventListener('click', function () {
                    if (!element.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                        nav.closeAllSubMenus();
                        nav.getElement().classList.add(constantsClasses_1.CLASS_ACTIVE);
                        element.classList.add(constantsClasses_1.CLASS_ACTIVE);
                    }
                    else {
                        element.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                    }
                });
                subClose.addEventListener('click', function () {
                    element.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                });
            });
        });
    };
    /**
     * Closes all menus and set buttons inactive
     * @private
     */
    Navigation.prototype.closeAll = function () {
        var _this = this;
        this.navigationElements.forEach(function (nav) {
            if (nav.getElement().classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                _this.menuOpenBtn.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                document.body.classList.remove(constantsClasses_1.NAV_OPEN);
                nav.getElement().classList.remove(constantsClasses_1.CLASS_ACTIVE);
                nav.closeAllSubMenus();
            }
        });
    };
    /**
     * Close dropdowns on outside click
     * @private
     */
    Navigation.prototype.checkForOutsideClick = function (event) {
        var elements = event.composedPath();
        // -2 because we want to skip document and window
        for (var i = 0; i < elements.length - 2; i++) {
            var el = elements[i];
            // Don't trigger if menu btn or navbar is clicked
            if (el.classList.contains('navbar') || el.classList.contains('header__menu__btn')) {
                return;
            }
        }
        this.closeAll();
    };
    return Navigation;
}());
exports.default = Navigation;
